import { useEffect, useState } from "react";

/** Fresh public appearance only: hidden, refreshing and failed responses must not keep paid styling alive. */
export const usePromotionVisibilityRefresh = (
  refetch: () => Promise<unknown>,
  enabled: boolean
) => {
  const [visible, setVisible] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  useEffect(() => {
    if (!enabled) {
      return;
    }

    setRefreshing(false);
    let active = true;
    let inFlight = false;
    const refresh = () => {
      if (inFlight) {
        return;
      }

      inFlight = true;
      setRefreshing(true);
      void refetch()
        .catch(() => undefined)
        .finally(() => {
          inFlight = false;

          if (active) {
            setRefreshing(false);
          }
        });
    };
    const visibility = () => {
      const next = document.visibilityState !== "hidden";
      setVisible(next);

      if (next) {
        refresh();
      }
    };
    setVisible(document.visibilityState !== "hidden");
    const timer = window.setInterval(() => {
      if (document.visibilityState !== "hidden") {
        refresh();
      }
    }, 60_000);
    document.addEventListener("visibilitychange", visibility);
    return () => {
      active = false;
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", visibility);
    };
  }, [enabled, refetch]);
  return enabled && visible && !refreshing;
};
